"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyService = void 0;
var tslib_1 = require("tslib");
var FilterTypings_1 = require("../../Views/Partials/Components/Filters/FilterTypings");
var lists_1 = require("../lists");
var search_1 = require("../search");
var String_utils_1 = require("../String.utils");
var TaxonomyApi_1 = require("./TaxonomyApi");
var taxonomyLoaders_1 = require("./taxonomyLoaders");
var productsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.ProductsTaxonomy,
    priority: 1,
};
var languagesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.LanguagesTaxonomy,
    priority: 2,
};
var newsCategoriesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.NewsCategoriesTaxonomy,
    priority: 3,
};
var eventCategoriesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.EventCategoriesTaxonomy,
    priority: 4,
};
var marketsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.MarketsTaxonomy,
    priority: 7,
};
var downloadTypeTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.DownloadTypeTaxonomy,
    priority: 5,
};
var segmentsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.SegmentsTaxonomy,
    priority: 5,
};
var subSegmentsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.SubSegmentsTaxonomy,
    priority: 5,
};
var brandsDhsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.BrandsDhstaxonomy,
    priority: 8,
};
var brandsDdsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.BrandsDdstaxonomy,
    priority: 9,
};
var solutionsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.SolutionsTaxonomy,
    priority: 10,
};
var applicationsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.ApplicationsTaxonomy,
    priority: 11,
};
var productTypesDdsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.ProductTypesDdstaxonomy,
    priority: 12,
};
var enclosuresDdsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.EnclosuresDdstaxonomy,
    priority: 13,
};
var careersTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.CareersTaxonomy,
    priority: 14,
};
var countriesTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.CountriesTaxonomy,
    priority: 0,
    taxonomyLoader: taxonomyLoaders_1.countryTaxonomyLoader,
};
var megatrendsTemplate = {
    type: TaxonomyApi_1.TaxonomyTypeEnum.MegatrendsTaxonomy,
    priority: 15,
};
// Set group filter and order in specific pages
var GROUP_FILTER_TEMPLATE_BY_LIST_TYPE = (_a = {},
    _a[FilterTypings_1.FilterableListTypeEnum.ProductCategories] = [marketsTemplate, segmentsTemplate],
    _a[FilterTypings_1.FilterableListTypeEnum.Products] = [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        tslib_1.__assign(tslib_1.__assign({}, marketsTemplate), { isCollapsed: true }),
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
    ],
    _a[FilterTypings_1.FilterableListTypeEnum.SearchResults] = [segmentsTemplate, downloadTypeTemplate],
    _a[FilterTypings_1.FilterableListTypeEnum.CaseStudies] = [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        marketsTemplate,
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
        megatrendsTemplate,
    ],
    _a[FilterTypings_1.FilterableListTypeEnum.Downloads] = [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        marketsTemplate,
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
    ],
    _a[FilterTypings_1.FilterableListTypeEnum.News] = [
        productsTemplate,
        newsCategoriesTemplate,
        eventCategoriesTemplate,
        marketsTemplate,
        segmentsTemplate,
        downloadTypeTemplate,
        subSegmentsTemplate,
        solutionsTemplate,
        applicationsTemplate,
        brandsDhsTemplate,
        brandsDdsTemplate,
        productTypesDdsTemplate,
        enclosuresDdsTemplate,
        careersTemplate,
        megatrendsTemplate,
    ],
    _a[FilterTypings_1.FilterableListTypeEnum.Events] = [
        tslib_1.__assign(tslib_1.__assign({}, marketsTemplate), { isCollapsed: true }),
        tslib_1.__assign(tslib_1.__assign({}, segmentsTemplate), { isCollapsed: false }),
        tslib_1.__assign(tslib_1.__assign({}, eventCategoriesTemplate), { isCollapsed: true }),
        tslib_1.__assign(tslib_1.__assign({}, languagesTemplate), { isCollapsed: true }),
        tslib_1.__assign(tslib_1.__assign({}, countriesTemplate), { isCollapsed: true }),
        tslib_1.__assign(tslib_1.__assign({}, subSegmentsTemplate), { isCollapsed: true }),
        tslib_1.__assign(tslib_1.__assign({}, megatrendsTemplate), { isCollapsed: true }),
    ],
    _a);
var TaxonomyService = /** @class */ (function () {
    function TaxonomyService() {
    }
    TaxonomyService.findFacetByTaxonomyGroupItem = function (taxonomy, facets, ignoreWarnings) {
        if (ignoreWarnings === void 0) { ignoreWarnings = false; }
        var matchedFacets = facets.filter(function (item) {
            var id = (0, lists_1.removePrefix)(item.id, search_1.FACET_PREFIX);
            return (0, String_utils_1.equalIgnoreCase)(id, taxonomy.filterValue);
        });
        var result = matchedFacets && matchedFacets.length > 0 ? matchedFacets[0] : null;
        if (!ignoreWarnings && !result) {
            // tslint:disable-next-line:no-console
            console.error("Facet for taxonomy group '".concat(taxonomy.filterValue, "' not found. Group ignored"));
        }
        return result;
    };
    TaxonomyService.findTaxonomyItemByFilterItem = function (filterItem, taxonomyItems) {
        var matchedTaxonomies = taxonomyItems
            ? taxonomyItems.filter(function (taxonomy) {
                return taxonomy.value === filterItem.queryValue;
            })
            : null;
        var result = matchedTaxonomies && matchedTaxonomies.length > 0 ? matchedTaxonomies[0] : null;
        if (!result) {
            // tslint:disable-next-line:no-console
            console.error("Taxonomy item for filter '".concat(filterItem.displayName, "' not found"));
        }
        return result;
    };
    TaxonomyService.convertToTaxonomyAliases = function (items) {
        var result = [];
        if (items) {
            result = items.map(function (item) {
                return item.type;
            });
        }
        return result;
    };
    TaxonomyService.convertToPriorityByType = function (items) {
        var result = {};
        if (items) {
            result = items.reduce(function (previousValue, currentValue) {
                var typeAlias = currentValue.type;
                previousValue[typeAlias] = currentValue.priority;
                return previousValue;
            }, {});
        }
        return result;
    };
    TaxonomyService.getGroupFilterTemplateByType = function (type, filterFunction) {
        if (filterFunction === void 0) { filterFunction = null; }
        var items = GROUP_FILTER_TEMPLATE_BY_LIST_TYPE[type];
        if (items && filterFunction) {
            items = items.filter(filterFunction);
        }
        return items;
    };
    TaxonomyService.getTaxonomyGroupByType = function (typeAlias, taxonomies) {
        var matchedTaxonomy = taxonomies.filter(function (taxonomy) { return taxonomy.typeAlias === typeAlias; });
        return (0, lists_1.getFirstOrDefault)(matchedTaxonomy, null);
    };
    TaxonomyService.getTranslation = function (taxonomyGroup, tags) {
        var result = null;
        if (taxonomyGroup && taxonomyGroup.items && tags) {
            result = tags.map(function (tag) {
                var matchedItems = taxonomyGroup.items
                    .filter(function (item) {
                    return (0, String_utils_1.equalIgnoreCase)(item.value, tag);
                })
                    .map(function (item) { return item.title; });
                return (0, lists_1.getFirstOrDefault)(matchedItems, tag);
            });
        }
        return result;
    };
    TaxonomyService.getTaxonomyItemByValue = function (taxonomyGroup, value) {
        var result;
        if (taxonomyGroup && taxonomyGroup.items && value) {
            var matchedItems = taxonomyGroup.items.filter(function (item) {
                return (0, String_utils_1.equalIgnoreCase)(item.value, value);
            });
            result = (0, lists_1.getFirstOrDefault)(matchedItems, null);
        }
        return result;
    };
    return TaxonomyService;
}());
exports.TaxonomyService = TaxonomyService;
